import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

//GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// LOCAL COMPONENTS
import RebateAttachments from './parts/RebateAttachments';

// MAIN COMPONENT
const CustomerRebatesList = () => (
  <Main>
    <Title title="Customer Rebates" tools={<Title.AddNewUsed />} />

    <Filters>
      <Filters.Button.Active />
      <Filters.Button.NewUsed />
      <Filters.Search name="rebateTitle" placeholder="Search by rebate title" />
      <Filters.Reset />
    </Filters>
    <Table mobilePreviewKeys={['rebate_title', 'date_updated']} />
  </Main>
);

// EXPORT
export default getListData(CustomerRebatesList, {
  key: SETTINGS.path,
  path: makePath(INTERFACE.settings, SETTINGS.customerRebates),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.dealerRebates.list
  },
  columns: [
    COLUMNS.updatedOn,
    {
      key: 'effective_date',
      label: 'Effective Date',
      component: Table.DateTime,
      width: 125
    },
    {
      key: 'expiration_date',
      label: 'Expiration Date',
      component: Table.DateTime,
      width: 125
    },
    {
      ...COLUMNS.newUsed,
      numeric: true,
      className: 'text-center',
      width: 35
    },
    {
      key: 'rebate_title',
      label: 'Title',
      width: 120
    },
    {
      key: 'rebate_program_code',
      label: 'Program Code',
      width: 75
    },
    {
      key: 'rebate_amount',
      label: 'Amount',
      component: ({ row: { original: { rebate_amount_lock, rebate_amount } } = {}, ...p }) => (
        <Table.Dollars
          {...p}
          icon={
            rebate_amount && {
              use: rebate_amount_lock ? 'lock-solid' : 'unlock-solid',
              className: 'd-inline position-relative mt-n1',
              fill: 'gray-800'
            }
          }
        />
      ),
      width: 85
    },
    {
      key: 'auto_rebate',
      label: 'Auto Apply',
      component: Table.Boolean,
      width: 85
    },
    {
      key: 'rebate_program_docs',
      label: 'Factory Program',
      component: RebateAttachments,
      width: 70
    },
    {
      key: 'customer_sig_forms',
      label: 'Signature Forms',
      component: RebateAttachments,
      width: 70
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active dealer rebates will be available while adding a sale.'
    },
    {
      key: 'updated_user_full_name',
      label: 'User',
      width: 80
    }
  ],
  actions: [ACTIONS.edit('dealer_rebate_id')]
});
